import React from 'react';
import { ArrowLeft, GitMerge, Pencil, PencilOff, RefreshCw, RotateCcw, Trash2, Truck } from 'lucide-react';
import Button from '../Button';
import { carrierLabel } from '../../constants/shipments';
import { RowTags } from './ShipmentCells';
import { StatusBadge } from './StatusBadge';

// Title, status and the action buttons of the shipment detail. A deleted shipment only offers "Obnovit".
const DetailHeader = ({ shipment: s, deleted, editMode, busy, onBack, onToggleEdit, onStatus, onMerge, onReprocess, onDelete, onRestore }) => (
  <header style={{ margin: '0 0 20px' }}>
    <button type="button" className="shp-textbtn" onClick={onBack} style={{ marginBottom: 12 }}>
      <ArrowLeft size={16} aria-hidden="true" /> Zpět na seznam
    </button>
    <div className="shp-head" style={{ margin: 0 }}>
      <div style={{ minWidth: 0, display: 'grid', gap: 8 }}>
        <h1 className="shp-title shp-wrap" dir="auto" style={{ alignItems: 'flex-start' }}>
          <Truck color="#E53935" aria-hidden="true" style={{ flex: 'none', marginTop: 2 }} />
          <span className="shp-wrap">{s.trackingNumber || s.orderRef || `Zásilka č. ${Number(s.id)}`}</span>
        </h1>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
          <StatusBadge status={s.status} />
          <span className="shp-muted shp-small">{carrierLabel(s.carrierCode, s.carrierName)}</span>
          <RowTags row={s} />
        </div>
      </div>
      <div className="shp-head__actions">
        {deleted ? (
          <Button icon={RotateCcw} loading={busy} onClick={onRestore}>Obnovit zásilku</Button>
        ) : (
          <>
            <Button variant={editMode ? 'primary' : 'secondary'} icon={editMode ? PencilOff : Pencil} aria-pressed={editMode} onClick={onToggleEdit}>
              {editMode ? 'Dokončit úpravy' : 'Upravit'}
            </Button>
            <Button variant="secondary" disabled={busy} onClick={onStatus}>Změnit stav</Button>
            <Button variant="secondary" icon={GitMerge} disabled={busy} onClick={onMerge}>Sloučit</Button>
            <Button variant="secondary" icon={RefreshCw} disabled={busy} onClick={onReprocess}>Znovu zpracovat AI</Button>
            <Button variant="danger" icon={Trash2} disabled={busy} onClick={onDelete}>Smazat</Button>
          </>
        )}
      </div>
    </div>
  </header>
);

export default DetailHeader;
